import { useQuery } from "@tanstack/react-query"
import { useMemo } from "react"
import { useAuth } from "~/features/auth/useAuth"
import type { DetailResult } from "~/features/detail/types"
import { GetStudyByIdDocument } from "~/graphql/generated/graphql"
import { useGraphQLClient } from "~/shared/api/GraphQLClientContext"
import { toStudyView } from "../projections"

export const useStudyDetail = (studyId: string | undefined): DetailResult => {
  const client = useGraphQLClient()
  const { status } = useAuth()

  const query = useQuery({
    queryKey: ["study", studyId],
    queryFn: () => client.request(GetStudyByIdDocument, { studyId: studyId ?? "" }),
    enabled: status === "signedIn" && Boolean(studyId),
  })

  const view = useMemo(() => {
    const study = query.data?.studyByID

    return study ? toStudyView(study) : undefined
  }, [query.data?.studyByID])

  // `isLoading` is `isPending && isFetching`, so a disabled query reports false and
  // the page falls through to its not-found state rather than spinning forever.
  return { view, isLoading: query.isLoading, isError: query.isError }
}
